import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { PendingFilterKey, PendingFilterState } from "./types";

function initialFilters(): PendingFilterState["filters"] {
  return {
    labelType: null,
    scope: "ACTION",
    region: null,
    search: "",
    batch: null,
    status: "NAO_INICIADO",
    page: 1,
    perPage: 20,
    sortBy: null,
    sortOrder: null,
  };
}

const INITIAL_STATE: PendingFilterState = { filters: initialFilters() };

const pendingFilterSlice = createSlice({
  name: "priceRemarkPendingFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter<K extends PendingFilterKey>(
      state: PendingFilterState,
      action: PayloadAction<{
        key: K;
        value: PendingFilterState["filters"][K];
      }>,
    ) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state: PendingFilterState) {
      state.filters = initialFilters();
    },
  },
});

export const { setFilter, resetFilters } = pendingFilterSlice.actions;
export default pendingFilterSlice.reducer;
